(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conf-giveaway"] && !Shopify.designMode) return;
  try {
    
  class ConfGiveawayForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-giveaway-form]');
      this.confirmation = this.querySelector('[data-confirmation]');
      this.error = this.querySelector('[data-giveaway-error]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.emailField = this.form?.querySelector('[name="email"]');
      if (!this.form) return;

      this.form.addEventListener('submit', this.#onSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.#onSubmit);
    }

    #onSubmit = async (event) => {
      event.preventDefault();
      if (this.form.classList.contains('is-submitting')) return;

      this.#clearError();
      this.#setSubmitting(true);

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'application/json' },
        });
        const data = await response.json().catch(() => ({}));

        if (data.duplicate === true) {
          this.#showDuplicate();
          return;
        }

        if (!response.ok || data.success !== true) {
          this.#showError();
          return;
        }

        this.#showConfirmation();
      } catch {
        this.#showError();
      } finally {
        if (!this.classList.contains('is-submitted')) {
          this.#setSubmitting(false);
        }
      }
    };

    #setSubmitting(isSubmitting) {
      this.form.classList.toggle('is-submitting', isSubmitting);
      this.form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      if (this.submitButton) this.submitButton.disabled = isSubmitting;
    }

    #showConfirmation() {
      this.classList.add('is-submitted');
      this.confirmation?.removeAttribute('hidden');
      this.confirmation?.querySelector('.conf-giveaway-confirmation')?.focus();
    }

    #showDuplicate() {
      this.emailField?.closest('.form_input-item')?.classList.add('has-error');
      this.#showError(this.dataset.duplicateMessage, this.emailField);
    }

    #showError(message, focusField) {
      if (!this.error) return;
      this.error.textContent = message || this.dataset.errorMessage || '';
      this.error.hidden = false;
      if (focusField) {
        if (this.error.id) focusField.setAttribute('aria-describedby', this.error.id);
        focusField.focus();
        return;
      }
      this.error.focus();
    }

    #clearError() {
      this.emailField?.closest('.form_input-item')?.classList.remove('has-error');
      this.emailField?.removeAttribute('aria-describedby');
      if (!this.error) return;
      this.error.hidden = true;
      this.error.textContent = '';
    }
  }

  if (!customElements.get('conf-giveaway-form')) {
    customElements.define('conf-giveaway-form', ConfGiveawayForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-savings-calculator"] && !Shopify.designMode) return;
  try {
    
  class EnergySavingsCalculator {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.currentStep = 1;
      this.totalSteps = 5;
      this.calculatorData = {
        propertyType: null,
        thermostatCount: 1,
        monthlyCost: 50,
        email: null,
      };

      this.init();
    }

    init() {
      this.cacheDOM();
      this.initializeDefaults();
      this.bindEvents();
      this.showStep(1);

      // The visible label is the abbreviation "Prev".
      const previousStepLabel = this.container?.dataset.previousStepLabel;
      if (this.prevBtn && previousStepLabel) {
        this.prevBtn.setAttribute('aria-label', previousStepLabel);
      }
    }

    initializeDefaults() {
      // Initialize calculator data from DOM default values
      if (this.thermostatRange) {
        this.calculatorData.thermostatCount = parseInt(this.thermostatRange.value);
      }
      if (this.costRange) {
        this.calculatorData.monthlyCost = parseInt(this.costRange.value);
      }
    }

    cacheDOM() {
      this.container = document.getElementById('calculator-block');
      if (!this.container) return;

      // Steps
      this.steps = this.container.querySelectorAll('.step');

      // Buttons - match the IDs configured in theme editor
      this.prevBtn = this.container.querySelector('#prevBtn');
      this.nextBtn = this.container.querySelector('#nextBtn');
      this.skipEmailBtn = this.container.querySelector('#skipEmailBtn');
      this.calculateBtn = this.container.querySelector('#calculate-btn');

      // Step 1: Home Type - radio inputs and option containers
      this.homeTypeRadios = this.container.querySelectorAll('input[name="home-type"]');
      this.options = this.container.querySelectorAll('.option');

      // Step 2: Thermostat Count
      this.thermostatRange = this.container.querySelector('#thermostat-count');

      // Step 3: Electricity Cost
      this.costRange = this.container.querySelector('#electricity-cost');

      // Step 4: Email
      this.emailForm = this.container.querySelector('#email-form');

      // Step Indicators
      this.currentStepDisplay = this.container.querySelector('#current-step');
      this.totalStepsDisplay = this.container.querySelector('#total-steps');
    }

    bindEvents() {
      if (!this.container) return;

      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.previousStep());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.nextStep());
      }
      if (this.skipEmailBtn) {
        this.skipEmailBtn.addEventListener('click', () => this.skipToResults());
      }

      // Step 1: Home Type - listen to radio input changes
      this.homeTypeRadios.forEach((radio) => {
        radio.addEventListener('change', (e) => this.handleHomeTypeChange(e.target));
      });

      // Step 1: Also allow clicking the option container to select the radio
      this.options.forEach((option) => {
        option.addEventListener('click', (e) => {
          const radio = option.querySelector('input[name="home-type"]');
          if (radio && e.target !== radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change'));
          }
        });
      });

      // Step 2: Thermostat count
      if (this.thermostatRange) {
        this.thermostatRange.addEventListener('input', (e) => {
          this.calculatorData.thermostatCount = parseInt(e.target.value);
          const range = e.target;
          range.value === range.max
            ? range.setAttribute('aria-valuetext', `${range.value}+`)
            : range.removeAttribute('aria-valuetext');

          // Emit custom event for thermostat count change
          const event = new CustomEvent('thermostat-count-changed', {
            detail: { count: parseInt(e.target.value) },
            bubbles: true,
          });

          this.container.dispatchEvent(event);
        });
      }

      // Step 3: Monthly cost
      if (this.costRange) {
        this.costRange.addEventListener('input', (e) => {
          this.calculatorData.monthlyCost = parseInt(e.target.value);
          e.target.setAttribute('aria-valuetext', `${e.target.dataset.currencySymbol ?? ''}${e.target.value}`);

          // Emit custom event for electricity cost change
          const event = new CustomEvent('electricity-cost-changed', {
            detail: { cost: parseInt(e.target.value) },
            bubbles: true,
          });
          this.container.dispatchEvent(event);
        });
      }

      // Step 4: Email form
      if (this.emailForm) {
        this.emailForm.addEventListener('submit', (e) => {
          e.preventDefault();
          // Get form data - validation handled by mysa-text-input
          const formData = new FormData(e.target);
          this.calculatorData.email = formData.get('email')?.trim() || null;
          this.handleEmailSubmission();
        });
      }
    }

    handleHomeTypeChange(radioInput) {
      // Remove selected class from all options
      this.options.forEach((opt) => opt.classList.remove('selected'));

      // Add selected class to the parent option of the checked radio
      const selectedOption = radioInput.closest('.option');
      if (selectedOption) {
        selectedOption.classList.add('selected');
      }

      // Store value from the radio input
      this.calculatorData.propertyType = radioInput.value;

      // Enable next button
      if (this.nextBtn) {
        this.nextBtn.disabled = false;
      }
    }

    showStep(stepNumber) {
      this.currentStep = stepNumber;

      // Hide all steps from assistive technology in the same pass that hides them visually.
      this.steps.forEach((step) => {
        step.classList.remove('active');
        step.hidden = true;
      });

      // Show current step
      const currentStepElement = this.container.querySelector(`#step-${stepNumber}`);
      if (currentStepElement) {
        currentStepElement.hidden = false;
        currentStepElement.classList.add('active');
      }

      // Update step indicator
      if (this.currentStepDisplay) {
        this.currentStepDisplay.textContent = stepNumber;
      }

      // Update button visibility
      this.updateButtons();
    }

    updateButtons() {
      // Previous button
      if (this.prevBtn) {
        this.prevBtn.style.display = this.currentStep > 1 && this.currentStep < 5 ? 'inline-block' : 'none';
      }

      // Next button
      if (this.nextBtn) {
        if (this.currentStep === 4 || this.currentStep === 5) {
          this.nextBtn.style.display = 'none';
        } else {
          this.nextBtn.style.display = 'inline-block';
          // Disable next on step 1 until option is selected
          if (this.currentStep === 1) {
            this.nextBtn.disabled = !this.calculatorData.propertyType;
          } else {
            this.nextBtn.disabled = false;
          }
        }
      }

      // Skip email button - only show on step 4
      if (this.skipEmailBtn) {
        this.skipEmailBtn.style.display = this.currentStep === 4 ? 'inline-block' : 'none';
      }
    }

    nextStep() {
      if (this.currentStep < this.totalSteps) {
        this.showStep(this.currentStep + 1);
        this.#focusCurrentStep();
      }
    }

    previousStep() {
      if (this.currentStep > 1) {
        this.showStep(this.currentStep - 1);
        this.#focusCurrentStep();
      }
    }

    /**
     * Next and Prev sit after the steps, so a new step opens behind the focused
     * button. Focus the step's control; its accessible name is the question.
     * A step with no control, such as the results, focuses its text instead.
     */
    #focusCurrentStep() {
      const step = this.container?.querySelector(`#step-${this.currentStep}`);
      if (!step) return;

      const control = step.querySelector(
        'input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), a[href]',
      );
      if (control instanceof HTMLElement) {
        control.focus();
        return;
      }

      const title = step.querySelector('.step__title');
      if (title instanceof HTMLElement) {
        title.focus();
        return;
      }

      step.setAttribute('tabindex', '-1');
      step.focus();
    }

    handleEmailSubmission() {
      // Calculate results first to get savings value
      this.calculate();

      const timestamp = Math.round(new Date().getTime() / 1000);
      const locale = document.documentElement.lang || 'en';
      const isFrench = locale.includes('fr');

      // Push calculator completion event to dataLayer
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'savings-calculator-submitted',
          data: {
            form_id: 'savings-calculator-submitted',
            email: this.calculatorData.email,
            date: timestamp,
            household_type: this.calculatorData.propertyType,
            total_household_thermostats: this.calculatorData.thermostatCount,
            estimated_monthly_bill: this.calculatorData.monthlyCost.toFixed(2),
            total_potential_savings: this.calculatorData.savings.toFixed(2),
            language: isFrench ? 'FR' : null,
            email_signup: 'TRUE',
          },
        });

        // Push email subscription event to dataLayer
        window.dataLayer.push({
          event: 'subscribe-general-submit',
          data: {
            form_id: 'subscribe-savings-calculator',
            email: this.calculatorData.email,
            date: timestamp,
          },
        });
      }

      // Navigate to results
      this.nextStep();
    }

    skipToResults() {
      // Skip email capture and go directly to results
      this.calculatorData.email = null;

      // Calculate results without email
      this.calculate();

      const timestamp = Math.round(new Date().getTime() / 1000);
      const locale = document.documentElement.lang || 'en';
      const isFrench = locale.includes('fr');

      // Push calculator completion event to dataLayer (without email)
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'savings-calculator-submitted',
          data: {
            form_id: 'savings-calculator-submitted',
            email: null,
            date: timestamp,
            household_type: this.calculatorData.propertyType,
            total_household_thermostats: this.calculatorData.thermostatCount,
            estimated_monthly_bill: this.calculatorData.monthlyCost.toFixed(2),
            total_potential_savings: this.calculatorData.savings.toFixed(2),
            language: isFrench ? 'FR' : null,
            email_signup: 'FALSE',
          },
        });
      }

      // Navigate to results
      this.nextStep();
    }

    calculate() {
      // Calculate total cost and savings based on thermostat count
      const units = this.calculatorData.thermostatCount;
      const cost = this.calculatorData.monthlyCost;
      const totalCost = units * cost;

      // Calculate savings based on number of units
      let savings = 0;
      if (units <= 3) {
        savings = totalCost * 0.208; // 20.8% savings for 1-3 thermostats
      } else {
        savings = totalCost * 0.26; // 26% savings for 4+ thermostats
      }

      // Format savings as currency
      const locale = document.documentElement.lang || 'en';
      const isFrench = locale.includes('fr');
      const formattedSavings = savings.toLocaleString(isFrench ? 'fr-CA' : 'en-US', {
        style: 'currency',
        currency: isFrench ? 'CAD' : 'USD',
      });

      // Display results in step 5
      const resultElement = this.container.querySelector('#savings-amount');
      if (resultElement) {
        resultElement.textContent = formattedSavings;
      }

      // Store calculated values for potential use
      this.calculatorData.savings = savings;
      this.calculatorData.formattedSavings = formattedSavings;
    }
  }

  // Initialize calculator when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const calculatorBlock = document.getElementById('calculator-block');
    if (calculatorBlock) {
      const sectionId = calculatorBlock.dataset.sectionId;
      new EnergySavingsCalculator(sectionId);
    }
  });

  // Reinitialize on theme editor events
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const calculatorBlock = event.target.querySelector('#calculator-block');
      if (calculatorBlock) {
        const sectionId = calculatorBlock.dataset.sectionId;
        new EnergySavingsCalculator(sectionId);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-learn-nav"] && !Shopify.designMode) return;
  try {
    
  class ProductLearnPageNav {
    static CONSTANTS = {
      SCROLL_AMOUNT: 200,
      SCROLL_MARGIN_REM: 10,
      RESIZE_DEBOUNCE: 150,
      SCROLL_TOLERANCE: 1,
    };

    constructor() {
      this.CONSTANTS = ProductLearnPageNav.CONSTANTS;

      this.navbarWrapper = document.querySelector('.pp-navbar-wrapper');
      this.navMenu = document.querySelector('.pp-nav-menu');
      this.navMenuInner = document.querySelector('.pp-nav-menu-inner');
      this.navLinks = document.querySelectorAll('.pp-nav-menu-link');
      this.scrollLeftBtn = document.querySelector('.pp-nav-scroll-btn--left');
      this.scrollRightBtn = document.querySelector('.pp-nav-scroll-btn--right');
      this.footer = document.querySelector('footer');
      this.heroCta = document.querySelector('.learn-more-hero-box .metaobject-product-buttons');

      this.sections = [];
      this.activeLink = null;
      this.isVisible = false;
      this.resizeTimeout = null;
      this.lastBottomValue = 0;
      this.rafId = null;

      this.scrollMarginPx = null;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.heroObserver = null;

      this.abortController = new AbortController();

      this.init();
    }

    init() {
      if (!this.navbarWrapper) return;

      this.cacheCalculations();
      this.setupHeroObserver();
      this.setupSections();
      this.setupScrollTracking();
      this.setupScrollButtons();
      this.setupResizeListener();
      this.updateScrollButtons();
    }

    cacheCalculations() {
      const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      this.scrollMarginPx = fontSize * this.CONSTANTS.SCROLL_MARGIN_REM;

      if (!this.navbarWrapper) return;
      const height = Math.ceil(this.navbarWrapper.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--learn-nav-block-size', `${height}px`);
    }

    setupHeroObserver() {
      if (!this.heroCta) return;

      this.heroObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          // Only show the bar once the user has scrolled PAST the hero CTA
          // (i.e. it's now above the viewport). On mobile the hero stacks
          // vertically so the CTA can sit below the fold at page load —
          // checking `!isIntersecting` alone would incorrectly show the bar
          // before any scrolling has happened.
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggleVisibility(scrolledPast);
        }
      });

      this.heroObserver.observe(this.heroCta);
    }

    toggleVisibility(visible) {
      if (!this.navbarWrapper) return;

      this.navbarWrapper.classList.toggle('is-visible', visible);
      this.isVisible = visible;

      if (!visible) {
        this.navbarWrapper.style.bottom = '';
        this.lastBottomValue = 0;

        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
      }
    }

    setupScrollTracking() {
      window.addEventListener(
        'scroll',
        () => {
          if (this.rafId) return;
          this.rafId = requestAnimationFrame(() => {
            this.updateActiveSection();
            if (this.isVisible) this.handleFooterCollision();
            this.rafId = null;
          });
        },
        { passive: true, signal: this.abortController.signal },
      );

      this.updateActiveSection();
    }

    updateActiveSection() {
      if (this.sections.length === 0) return;

      const triggerY = this.scrollMarginPx + this.CONSTANTS.SCROLL_TOLERANCE;
      let active = null;

      for (const section of this.sections) {
        if (section.element.getBoundingClientRect().top <= triggerY) active = section;
      }

      if (active && active.link !== this.activeLink) this.setActiveLink(active.link);
    }

    handleFooterCollision() {
      if (!this.footer || !this.navbarWrapper) return;

      const footerRect = this.footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const footerDistanceFromBottom = viewportHeight - footerRect.top;
      const newBottomValue = Math.max(0, footerDistanceFromBottom);

      if (Math.abs(newBottomValue - this.lastBottomValue) > 1) {
        this.navbarWrapper.style.bottom = `${newBottomValue}px`;
        this.lastBottomValue = newBottomValue;
      }
    }

    smoothScrollTo(scrollLeft) {
      if (!this.navMenuInner) return;

      this.navMenuInner.scrollTo({
        left: scrollLeft,
        behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    setupSections() {
      for (const link of this.navLinks) {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) continue;

        const sectionId = href.substring(1);
        const section = document.getElementById(sectionId);
        if (!section) continue;

        this.sections.push({ id: sectionId, element: section, link });

        link.addEventListener('click', () => this.setActiveLink(link), { signal: this.abortController.signal });
      }
    }

    setupScrollButtons() {
      if (this.scrollLeftBtn) {
        this.scrollLeftBtn.addEventListener('click', () => this.scrollNavMenu('left'), {
          signal: this.abortController.signal,
        });
      }

      if (this.scrollRightBtn) {
        this.scrollRightBtn.addEventListener('click', () => this.scrollNavMenu('right'), {
          signal: this.abortController.signal,
        });
      }

      if (this.navMenuInner) {
        this.navMenuInner.addEventListener('scroll', () => this.updateScrollButtons(), {
          signal: this.abortController.signal,
        });

        this.navMenuInner.addEventListener(
          'wheel',
          (e) => {
            if (e.shiftKey && Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
              e.preventDefault();
              this.navMenuInner.scrollLeft += e.deltaY;
            }
          },
          { passive: false, signal: this.abortController.signal },
        );
      }
    }

    setupResizeListener() {
      window.addEventListener(
        'resize',
        () => {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => this.handleResize(), this.CONSTANTS.RESIZE_DEBOUNCE);
        },
        { signal: this.abortController.signal },
      );
    }

    handleResize() {
      this.cacheCalculations();
      this.updateActiveSection();
      this.scrollToActiveLink();
      this.updateScrollButtons();
    }

    setActiveLink(link) {
      for (const l of this.navLinks) {
        l.classList.remove('active');
        l.removeAttribute('aria-current');
      }
      link.classList.add('active');
      link.setAttribute('aria-current', 'true');
      this.activeLink = link;
      this.scrollToActiveLink();
    }

    scrollToActiveLink() {
      if (!this.activeLink || !this.navMenuInner || !this.navMenu) return;

      const navMenuRect = this.navMenu.getBoundingClientRect();
      const activeLinkRect = this.activeLink.getBoundingClientRect();
      const navMenuInnerRect = this.navMenuInner.getBoundingClientRect();

      const activeLinkLeft = activeLinkRect.left - navMenuInnerRect.left;
      const activeLinkCenter = activeLinkLeft + activeLinkRect.width / 2;
      const targetScrollLeft = activeLinkCenter - navMenuRect.width / 2;

      this.smoothScrollTo(Math.max(0, targetScrollLeft));
    }

    scrollNavMenu(direction) {
      if (!this.navMenuInner) return;

      const scrollAmount = direction === 'left' ? -this.CONSTANTS.SCROLL_AMOUNT : this.CONSTANTS.SCROLL_AMOUNT;
      this.smoothScrollTo(this.navMenuInner.scrollLeft + scrollAmount);
    }

    updateScrollButtons() {
      if (!this.navMenuInner || !this.scrollLeftBtn || !this.scrollRightBtn) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.navMenuInner;
      const maxScrollLeft = scrollWidth - clientWidth;
      const hasOverflow = scrollWidth > clientWidth;
      const tolerance = this.CONSTANTS.SCROLL_TOLERANCE;

      if (hasOverflow) {
        const isAtStart = scrollLeft <= tolerance;
        const isAtEnd = scrollLeft >= maxScrollLeft - tolerance;

        this.scrollLeftBtn.classList.add('visible');
        this.scrollRightBtn.classList.add('visible');
        this.scrollLeftBtn.disabled = isAtStart;
        this.scrollRightBtn.disabled = isAtEnd;
        this.scrollLeftBtn.style.opacity = isAtStart ? '0.5' : '1';
        this.scrollRightBtn.style.opacity = isAtEnd ? '0.5' : '1';
      } else {
        this.scrollLeftBtn.classList.remove('visible');
        this.scrollRightBtn.classList.remove('visible');
      }
    }

    destroy() {
      if (this.heroObserver) this.heroObserver.disconnect();
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.abortController.abort();
    }
  }

  let navInstance = null;

  const initNav = () => {
    if (navInstance) navInstance.destroy();
    navInstance = new ProductLearnPageNav();
  };

  document.addEventListener('DOMContentLoaded', initNav);
  document.addEventListener('shopify:section:load', initNav);

  } catch(e) { console.error(e); }
})();
})();
